const labels = {
  populationCurrent: 'Population 2016',
  populationProjection: 'Population 2021 (Projection)',
  femalePopulationCurrent: 'Female Population 2016',
  malePopulationCurrent: 'Male Population 2016',
  diversityIndex: 'Diversity Index',
  white: 'White',
  hispanic: 'Hispanic or Latino',
  africanAmerican: 'Black or African American',
  otherRace: 'Some Other Race',
  twoOrMore: 'Two or More Races',
  asian: 'Asian',
  americanIndian: 'American Indian',
  hawaiian: 'Native Hawaiian or Pacific Islander',
  population19: { long: '19 & Under', short: '0-19' },
  population34: '20-34',
  population44: '35-44',
  population64: '45-64',
  populationAbove65: { long: '65 & Older', short: '65+' },
  laborForce: 'Total',
  laborForceEmployed: 'Employed',
  laborForceUnemployed: 'Unemployed',
  educationAssociates: 'Associates Degree',
  educationBachelor: 'Bachelor Degree',
  educationGED: 'GED',
  educationGrad: 'Graduate Degree',
  educationHighSchool: 'High School Degree',
  educationNoHighSchool: 'No High School',
  educationSomeCollege: 'Some College',
  educationSomeHighSchool: 'Some High School',

  // employment by industry
  agriculture: 'Agriculture/Forestry/Fishing/Hunting',
  mining: 'Mining/Quarrying/Oil & Gas Extraction',
  construction: 'Construction',
  manufacturing: 'Manufacturing',
  wholesaleTrade: 'Wholesale Trade',
  retailTrade: 'Retail Trade',
  transportation: 'Transportation/Warehousing',
  utilities: 'Utilities',
  information: 'Information',
  finance: 'Finance/Insurance',
  realEstate: 'Real Estate/Rental/Leasing',
  technology: 'Professional/Scientific/Tech Services',
  management: 'Management of Companies/Enterprises',
  administration: 'Admin/Support/Waste Management Services',
  education: 'Educational Services',
  healthcare: 'Health Care/Social Assistance',
  arts: 'Arts/Entertainment/Recreation',
  food: 'Accommodation/Food Services',
  other: 'Other Services',
  publicAdministration: 'Public Administration',
};

export function addLabels(data) {
  return Object.keys(data).reduce((carry, key) => {
    return [...carry, [labels[key], data[key]]];
  }, []).sort((a, b) => {
    return b[1] - a[1];
  });
}

export function formatForChart(data, labelType = 'long') {
  return Object.keys(data).map(key => {
    return {
      name: labels[key][labelType] || labels[key],
      value: data[key],
    };
  });
}



// WEBPACK FOOTER //
// ./src/components/Areas/Util/label.js